<div class="tab-pane" id="transformers">
    <div class="content_view">
        <div class="widgetList">
            <div class="widgetList">
            <div class="widget-item">Oil Temperature</div>
            <div class="widget-item">Winding Temperature</div>
            <div class="widget-item">Oil Level</div>
            <div class="widget-item">Pressure Relief Valve</div>
            <div class="widget-item">Buccholz Relay</div>
            <div class="widget-item">Oil Surge Relay</div>
            <div class="widget-item">Smart Breather</div>
            <div class="widget-item">Energy Meter</div>
            <div class="widget-item">Energy Meter</div>
        </div>
    </div>
</div>
<div class="transformerList">
    <!-- Good Stage -->
    <div class="transformerSingle goodHealth">
        <div class="transformerNameIcon">
            <h4>Milton Test System 2<span>ELMIN031023-00007</span></h4>
            <div class="transformerStatus">
                <img src="assets/images/green.png" />
            </div>
        </div>
        <div class="transformerInner">
            <img src="assets/images/transformer-power.png" />
            <button (click)="transformerDetailScreen()" class="points point1">1</button>
            <button class="points point2">2</button>
            <button class="points point3">3</button>
            <button class="points point4">4</button>
            <button class="points point5">5</button>
            <button class="points point6">6</button>
            <button class="points point7">7</button>
            <button class="points point8">8</button>
        </div>
        
    </div>
    <!-- <div class="transformerSingle badHealth">
        <div class="transformerNameIcon">
            <h4>Milton Test System 2<span>ELMIN031023-00007</span></h4>
            <div class="transformerStatus">
                <img src="assets/images/red.png" />
            </div>
        </div>
        <div class="transformerInner">
            <img src="assets/images/transformer-power.png" />
            <a href="analysis.html" class="points point1 yellowBoxBg fdfd04">1</a>
            <a href="analysis.html" class="points point2">2</a>
            <a href="analysis.html" class="points point3">3</a>
            <a href="analysis.html" class="points point4">4</a>
            <a href="analysis.html" class="points point5">5</a>
            <a href="analysis.html" class="points point6">6</a>
            <a href="analysis.html" class="points point7">7</a>
            <a href="analysis.html" class="points point8">8</a>
        </div>
    </div> -->
   
</div>